import { render, staticRenderFns } from "./CurrencyComponent.vue?vue&type=template&id=3704db14"
import script from "./CurrencyComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports